/**
 * Shape-tolerant readers for the backend error body (spec §3.2).
 *
 * The backend is migrating from bare `{ error: '<string>' }` bodies to the
 * unified envelope `{ success: false, error: { code, status, message, ... } }`
 * (RES-97). These readers accept both, from either HTTP stack's carrier:
 * RTK Query errors ({ status, data }) and axios errors ({ response: { data } }).
 */
const getData = (error: unknown): any => {
  if (!error || typeof error !== 'object') return undefined;
  const e = error as Record<string, any>;
  return e.data ?? e.response?.data;
};

export const getServerErrorMessage = (error: unknown): string | undefined => {
  const data = getData(error);
  if (!data || typeof data !== 'object') return undefined;
  const err = (data as Record<string, any>).error;
  if (err && typeof err === 'object' && typeof err.message === 'string') return err.message; // unified
  if (typeof err === 'string') return err; // legacy bare shape
  if (typeof (data as Record<string, any>).message === 'string') return (data as Record<string, any>).message;
  return undefined;
};

export const getServerErrorCode = (error: unknown): string | undefined => {
  const data = getData(error);
  const code = data?.error?.code;
  return typeof code === 'string' ? code : undefined;
};
